module.exports = __webpack_public_path__ + "media/flags/mv-1c36cf0d.svg";